import { legacy_createStore as createStore, combineReducers, applyMiddleware, compose } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { thunk } from 'redux-thunk';

//models
import staysReducer from './ducks/models/stays';
import clientReducer from './ducks/models/client';
import rfidsReducer from './ducks/models/rfids';
import callsReducer from './ducks/models/calls';
import cashboxOperationsReducer from './ducks/models/cashboxOperations';
import tariffsReducer from './ducks/models/tariffs';
import reportsReducer from './ducks/models/reports';
import rules from './ducks/models/rules';
import refill from './ducks/models/refill';
import events from './ducks/models/events';
import processing from './ducks/models/processing';
import using from './ducks/models/using';
import working from './ducks/models/working';
import benefits from './ducks/models/benefits';
import promises from './ducks/models/promises';

//interface
import staysGridReducer from './ducks/interface/staysGrid';
import clientsCardReducer from './ducks/interface/clientsCard';
import rfidsGridReducer from './ducks/interface/rfidsGrid';
import cashboxOperationsGridReducer from './ducks/interface/cashboxOperationsGrid';
import callsGridReducer from './ducks/interface/callsGrid';
import tariffsGridReducer from './ducks/interface/tariffsGrid';
import refillGrid from './ducks/interface/refillGrid';
import eventsReducer from './ducks/interface/eventsGrid';
import usingReducer from './ducks/interface/usingGrid';
import workingReducer from './ducks/interface/workingGrid';
import benefitsReducer from './ducks/interface/benefitsGrid';
import promisesReducer from './ducks/interface/promisesGrid';

//widget
import widgetPopupReducer from './ducks/interface/widgetPopup';

const reducers = combineReducers({
  //model
  stays: staysReducer,
  client: clientReducer,
  rfids: rfidsReducer,
  cashboxOperations: cashboxOperationsReducer,
  calls: callsReducer,
  tariffs: tariffsReducer,
  reports: reportsReducer,
  rules: rules,
  refill: refill,
  events: events,
  processing: processing,
  using: using,
  working: working,
  benefits: benefits,
  promises: promises,

  //interface
  staysGrid: staysGridReducer,
  clientsCard: clientsCardReducer,
  rfidsGrid: rfidsGridReducer,
  callsGrid: callsGridReducer,
  cashboxOperationsGrid: cashboxOperationsGridReducer,
  tariffsGrid: tariffsGridReducer,
  refillGrid: refillGrid,
  eventsGrid: eventsReducer,
  usingGrid: usingReducer,
  workingGrid: workingReducer,
  benefitsGrid: benefitsReducer,
  promisesGrid: promisesReducer,

  //other
  widgetPopup: widgetPopupReducer,
  form: formReducer,
});

const composeEnhancers = typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({}) : compose;
const enhancer = composeEnhancers(applyMiddleware(thunk));
// const store = createStore(reducers, applyMiddleware(thunk));
const store = createStore(reducers, enhancer);

export default store;
